export default __webpack_public_path__ + "static/media/LI.5883050e.ico";